import {
    DestroyRef, Directive, inject, OnInit
} from "@angular/core";
import { ProcessingDirective } from "../../application/directives/processing/processing.directive";
import { ButtonDirective } from "../../application/directives/button/button.directive";
import { ListDataSourceService } from "../services/list-data-source.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

/**
 * Directive for bulk action buttons that automatically disables when no items are selected.
 *
 * This directive should be applied to buttons that perform actions on selected items in a table.
 * It automatically disables the button when no items are selected in the ListDataSource.
 *
 * Usage:
 * ```html
 * <button mat-raised-button mgdBulkActionsButton>Actions</button>
 * ```
 */
@Directive({
    selector: "[mgdBulkActionsButton]",
    hostDirectives: [
        {
            directive: ButtonDirective,
            inputs: ["stopClickEventPropagation"]
        }
    ]
})
export class BulkActionsButtonDirective implements OnInit {

    private readonly _dataSource = inject(ListDataSourceService);
    private readonly _processing = inject(ProcessingDirective, { self: true });
    private readonly _button = inject(ButtonDirective, { self: true });
    private readonly _destroyRef = inject(DestroyRef);

    ngOnInit(): void {

        this._button.buttonType = "save";
        // Subscribe to selection changes and disable button when selection is empty
        this._dataSource.selectedData.changed
            .pipe(takeUntilDestroyed(this._destroyRef))
            .subscribe(() => {
                this._processing.setSelfDisabled(this._dataSource.selectedData.isEmpty());
            });

        // Set initial state
        this._processing.setSelfDisabled(this._dataSource.selectedData.isEmpty());
    }
}
